import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BodyTextMedium } from '../Typography/Typography';
import * as styles from './Radio.module.scss';
/**
 * @deprecated
 */
export const Radio = ({ value, label, onChange, groupName, testID, ...props }) => {
    return (_jsxs("label", { "data-testid": testID, className: styles.container, children: [_jsx("input", { type: "radio", className: styles.radio, name: groupName, value: value, onChange: event => {
                    onChange(event, value);
                }, ...('isSelected' in props ? { checked: props.isSelected } : {}) }), _jsx(BodyTextMedium, { as: "span", fontColor: "gray65", children: label })] }));
};
